// extracted by mini-css-extract-plugin
export default {"nav":"Sidebar_nav__5tGQ3","profile":"Sidebar_profile__zfxbW"};